import { createFileRoute } from '@tanstack/react-router'

import { AccountSettingsPage } from '@/features/auth/pages/account-settings'

// Wrapped for the same `NextPageWithLayout` reason as the other account pages;
// it sets no `getLayout`, so it stays inside the customer shell.
export const Route = createFileRoute('/_shell/account/settings')({
  component: () => <AccountSettingsPage />,
})
